<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>প্ৰতিলিপি ৰচিদ</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <span class="title">প্ৰতিলিপি ৰচিদ</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">

          <b-row style="padding-top: 10px;">
                <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                  <span style="font-weight:600" >উপভোক্তা নম্বৰ <span class="text-danger">*</span></span>
                </b-col>
                <b-col col cols="8" sm="8" md="8" lg="4">
                    <b-form-input type="text" maxlength="12"  id="consNo" placeholder="উপভোক্তা নম্বৰ" autocomplete="off" trim required />
                </b-col>
                <b-col col cols="4" sm="3" md="3" lg="1">
                      <b-button @click="sendOtp()" block pill variant="primary" size="md" class="go" style="width:100%">
                        <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                      </b-button>
                </b-col>
              </b-row>
      </br>

      <div id="MobileUpdateDiv" style="display:none">
           <b-row>
             <b-col cols=12>
                  <h4 style="color:red">Unable to send OTP. Mobile Number Not Updated</h4>
                 <a href="MobileUpdate" >Click Here to Update Your Mobile Number</a>
             </b-col>
           </b-row>
         </div>
    <div id="successDiv" class="hideDetails">
            <!-- <b-card header-bg-variant="light" header-text-variant="white" header="Payment Receipt" class="cardStyle">
           -->
           <b-row>
             <b-col cols=12>
               <span class="heading">ৰচিদৰ বিৱৰণ</span>
             </b-col>
           </b-row>
           <hr/>

              <b-row class="paddingRow">
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="label">ৰচিদ নম্বৰ : </span>
                </b-col>
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="" id="receiptNo"></span>
                </b-col>
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="label">বিল নম্বৰ : </span>
                </b-col>
                <b-col cols="12" sm="3" md="3" lg="3">
                  <span class="" id="billNo"></span>
                </b-col>
              </b-row>
                <br>
              <b-row class="paddingRow">
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="label">মুঠ বিল : </span>
                </b-col>
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="" id="netBill"></span>
                </b-col>
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="label">পৰিশোধ কৰা পৰিমাণ : </span>
                </b-col>
                <b-col cols="12" sm="3" md="3" lg="3">
                  <span class="" id="paidAmt"></span>
                </b-col>
              </b-row>
                <br>
              <b-row class="paddingRow">
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="label">পৰিশোধ মোড :</span>
                </b-col>
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="" id="payMode"></span>
                </b-col>
                <b-col cols="12" sm="2" md="2" lg="2">
                  <span class="label">পৰিশোধৰ তাৰিখ : </span>
                </b-col>
                <b-col cols="12" sm="3" md="3" lg="3">
                  <span class="" id="payDate"></span>
                </b-col>
              </b-row>

              <br>
              <b-row>
                <b-col col cols="12" sm="3" md="3" lg="3" offset-sm="2" offfset-md="2" offset-lg="2">

                  <a id="pdfLink" target="_blank" href="">
                    <b-button block squared variant="primary">
                      <b-icon icon="receipt-cutoff" animation=""></b-icon> Download Receipt
                    </b-button>
                  </a>
                </b-col>
              </b-row>
            <!-- </b-card> -->
      </div>
      <b-row id="errorDiv" style="display:none">
        <b-col cols=12 align="center">
          <h2 style="color:red">ERROR : transaction is already processed.</h2>
          <br><br>
          <b-button>Go Back</b-button>
        </b-col>
      </b-row>

</div>

  </b-container>
<br><br>
</b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg"> DEMO </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay
      :show="show1"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style=""
      variant="dark"
      id="loader"
    >
      Enter the OTP received in your mobile number <b> {{ consMobile }} </b>
      <b-form-input type="number" id="otp" ></b-form-input><br>
      <b-button class="btn" variant="primary" id="success-btn" @click="verifyOtp()" >Verify</b-button> &nbsp&nbsp
      <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
  </b-overlay>
    </b-modal>
  </div>

</template>


<script>
import HeaderMobile from '@/components/HeaderMobile.vue'
import HeaderFixed from '@/components/HeaderFixed.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

var mobileNo = "";
var consNo = "";

export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
      show1:false,
      consMobile:""


    }
  },
  methods: {
    

    closeModal(){
      this.$bvModal.hide('model')
    },

    sendOtp()
      {
       var parent =this;
       
       consNo = document.getElementById("consNo").value;
       if ((consNo.toString().length!=12))
           {
             this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }
           parent.show= true;
        axios.post(parent.$urlArms+'/RestAPI/website/otpValidation?consNo='+consNo)
           .then((response) => {

           console.log(response.data);
           var data=response.data;
           var status = data.msg;

           if(status=="success")
           {
           
               if (data.otpGenerated == "Y") {
                 parent.$bvToast.toast('OTP Sent Successfully !', {
                   title: `Success`,
                   variant: 'success',
                   solid: true
                 });
                 parent.$bvModal.show('otpModal');

               }
               else{
                parent.$bvToast.toast('OTP Generation Failed !', {
                   title: `Failed`,
                   variant: 'danger',
                   solid: true
                 });
               }
             
           }
           
           else
           {
              parent.show= false;
             parent.$bvModal.show('model');
             document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";

           }

         })
         .catch((e) => {
         console.log("Caught", e);
         this.show= false;
       })


      },


      resendOtp()
      {
        var parent =this;

        parent.show1= true;
        axios.post(this.$urlArms+"/RestAPI/website/resendOTP?consNo="+consNo).then(function(response) {
          parent.show1= false;
          if (response.data.msg == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
          }
        else {
            parent.$bvToast.toast('OTP Could not Sent !', {
              title: `danger`,
              variant: 'danger',
              solid: true
            });
          }
        });
      },

  verifyOtp()
    {
      var parent =this;
      var otp = document.getElementById("otp").value;
      parent.show1= true;
      axios.post(parent.$urlCommon+"/api/VerifyOtpReceipt?consNo="+consNo+"&otp="+otp).then(function(response) {
        parent.show1= false;
        parent.show= false;
        console.log(response.data);

        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Verified Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          parent.$bvModal.hide('otpModal');
          document.getElementById("successDiv").classList.add("showDetails");
          var data=response.data.receiptData.body[0];
          var msg= data.msg;
          //console.log(msg);
      //    this.show= false;

          if(msg=="success") {
            var res=data.payment_DATE.split("-");
            var payDate= res[2]+"-"+res[1]+"-"+res[0];
            document.getElementById("successDiv").classList.add("showDetails");
            document.getElementById("receiptNo").innerHTML=data.receipt_NO;
            document.getElementById("billNo").innerHTML=data.bill_NO;
            document.getElementById("netBill").innerHTML=data.net_BILL;
            document.getElementById("paidAmt").innerHTML=data.paid_AMOUNT;

            document.getElementById("payMode").innerHTML=data.payment_MODE;
            document.getElementById("payDate").innerHTML=payDate;
            document.getElementById("pdfLink").href=data.receiptlink;


          }
          else
          {
            parent.show= false;
            parent.$bvModal.show("model");
            document.getElementById("msg").innerHTML="Sorry, Consumer / Receipt Not Found";
            document.getElementById("BillDetails").classList.remove("showBillDetails");
          }

        }
      else {
          parent.$bvToast.toast('OTP not Valid !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
          parent.show1= false;
          parent.show= false;
        }
      });
    },


  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
td{
  padding:0.3rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingLeft30px{
  padding-left: 30px;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
  @font-face {
    font-family: Assamese_Font;
    src: url("../assets/Assamese_font/KirtanUni.ttf");
  }
  div{
      font-family: arial,Assamese_Font;
  }
</style>
